




import Carrusel from './SRCproyect/carrusel';
import Nav from './nav';
import ChangeTittle from './titilechanger';

function Proyect(){
    ChangeTittle();
    return(
        <div>
            <Nav/>
            <Carrusel/>
        </div>
    );
}


export default Proyect;